export default {
    getWealthplanNotes: (state) => {
        return state.wealthplan.notes;
    },
};
